"use client";

import React, { useEffect } from "react";
import PortfolioColorscheme from "@/app/components/PortfolioColorscheme/PortfolioColorscheme";
import PortfolioResponsiveDisplays from "@/app/components/PortfolioResponsiveDisplays/PortfolioResponsiveDisplays";
import PortfolioTypography from "@/app/components/PortfolioTypography/PortfolioTypography";
import WebsiteLogo from "@/app/components/WebsiteLogo/websitelogo";
import { WebsiteSubtitle } from "@/app/components/WebsiteSubtitle/WebsiteSubtitle";
import PortfolioTechStack from "@/app/components/PortfolioTechStack/PortfolioTechStack";
import FigmaLogo from "@/app/components/icons/figmaLogo";
import HTML5Logo from "@/app/components/icons/HTML5Logo";
import CSS3Logo from "@/app/components/icons/CSS3Logo";
import JSLogo from "@/app/components/icons/JSLogo";
import AboutIntroducionSection from "@/components/common/FirstBlockAbout";
import PHPLogo from "@/app/components/icons/PHPLogo";
import WordpressLogo from "@/app/components/icons/WordpressLogo";

export default function MMADigital() {
    const primaryColor = "#002A63";

    useEffect(() => {
        const link = document.createElement("link");
        link.href = "https://fonts.googleapis.com/css2?family=Bakbak+One&display=swap";
        link.rel = "stylesheet";
        document.head.appendChild(link);

        return () => {
            document.head.removeChild(link);
        };
    }, []);

    return (
        <>
            <section className="flex flex-col gap-[100px] my-[35px]">
                <div>
                    <WebsiteLogo imageSrc="https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FMMADigital%2FMMALogo.svg?alt=media&token=c216bc40-72c0-4ecf-95f8-afda56d2bd4b" />
                    <AboutIntroducionSection
                        media={{
                            type: "image",
                            src: "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FMMADigital%2FmmadigitalHero.png?alt=media&token=9ccef531-ecc4-4848-9beb-4bf6cefa1319Z",
                        }}
                        primaryColor={primaryColor}
                    />
                    <WebsiteSubtitle
                        text="For MMA Digital, we crafted a complete design ecosystem focusing on visual identity and user experience. We delivered a detailed brand guideline and a modern logo to anchor the brand. Our process included creating wireframes, high-fidelity prototypes, and custom animations to validate interactions. We finalized the project with a comprehensive UI kit for both desktop and mobile, ensuring a pixel-perfect handover for the development team."
                        title="Deliverables"
                        tags={["TYPOGRAPHY", "COLORSCHEME", "RESPONSIVE DESIGN", "TECH STACK"]}
                        buttonHref="https://mmadigital.io/"
                    />
                </div>

                <PortfolioTypography
                    typographyData={[
                        {
                            headline: "Streamlining legal access through digital innovation.",
                            fontFamily: "Bakbak One",
                            fontSize: "56px",
                            letterSpacing: "0%",
                            lineHeight: "115%",
                            textColor: "#2c2d2c",
                        },
                    ]}
                    primaryColor={primaryColor}
                />
                <PortfolioColorscheme
                    ColorschemeData={[
                        {
                            title: "Accent",
                            color: "#2C6ECE",
                            rgb: "#2C6ECE",
                            textColor: "#fff",
                        },
                        {
                            title: "Black",
                            color: "#010D1C",
                            rgb: "#010D1C",
                            textColor: "#FFFFFF",
                        },
                        {
                            title: "White",
                            color: "#FFFFFF",
                            rgb: "#FFFFFF",
                            textColor: "#2c2d2c",
                        },
                        {
                            title: "Additional",
                            color: "#081A2D",
                            rgb: "#081A2D",
                            textColor: "#fff",
                        },
                        {
                            title: "Background",
                            color: "#EBEBEB",
                            rgb: "#EBEBEB",
                            textColor: "#2c2d2c",
                        },
                    ]}
                    primaryColor={primaryColor}
                />
                {/* <PortfolioResponsiveDisplays
                    ResponsiveDisplaysData={[
                        {
                            type: "image",
                            content:
                                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FGSL%2FgslMac.png?alt=media&token=51c573c9-4cef-4ca7-85dd-0611fc544732",
                        },
                        {
                            type: "image",
                            content:
                                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FGSL%2Fgslipad.png?alt=media&token=6721f005-d842-463b-b523-ec6c4c7dbd2d",
                        },
                        {
                            type: "image",
                            content:
                                "https://firebasestorage.googleapis.com/v0/b/enjoyabledesign-a7576.appspot.com/o/Website%20images%2FPortfolio%20Image%20For%20Each%20Project%2FGSL%2Fgsliphone.png?alt=media&token=0b734b78-2ee6-4585-bd00-c6d0fb2e5030",
                        },
                    ]}
                    primaryColor={primaryColor}
                /> */}
                <PortfolioTechStack
                    primaryColor={primaryColor}
                    blocks={[
                        {
                            title: "Design",
                            titleColor: "#2c2d2c",
                            icons: [<FigmaLogo key="figma" />],
                            opacity: 5,
                        },
                        {
                            title: "Layout Development",
                            titleColor: "#2c2d2c",
                            icons: [<HTML5Logo key="html" />, <CSS3Logo key="css" />, <JSLogo key="js" />],
                            opacity: 15,
                        },
                        {
                            title: "Theme Development",
                            titleColor: "#2c2d2c",
                            icons: [<PHPLogo key="php" />],
                            opacity: 25,
                        },
                        {
                            title: "Publishing",
                            titleColor: "#2c2d2c",
                            icons: [<WordpressLogo key="wp" />],
                            opacity: 30,
                        },
                    ]}
                />
            </section>
        </>
    );
}
